import styled from "styled-components";

import { H1_2XL_New, H4New, breakpoints } from "../index";

export const HeroTextH1 = styled(H1_2XL_New)`
    text-align: center;
    width: 100%;
    margin: 0 auto;

    /* Mobile: */
    max-width: 15rem; /* 240px */

    /* Tablet: */
    @media (min-width: ${breakpoints.md}rem) {
        max-width: 41.5rem; /* 664px */
    }

    /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        max-width: 57.75rem; /* 924px */
    }

    /* Screens with 700px - 1000px height range - matches tablet: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            max-width: 41.5rem; /* 664px */
        }
    }
`;

export const HeroTextH4 = styled(H4New)`
    margin: 0 auto;
    width: 100%;
    text-align: center;

    /* Tablet: */
    @media (min-width: ${breakpoints.md}rem) {
        max-width: 36.75rem; /* 588px */
    }

    /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        max-width: 45.75rem; /* 732px */
    }

    /* Screens with 700px - 1000px height range - matches tablet: */
    @media ${breakpoints.laptopHeightsRange} {
        @media (min-width: ${breakpoints.lg}rem) {
            max-width: 36.75rem; /* 588px */
        }
    }
`;
